export const DRAFT_TTL = 7 * 24 * 60 * 60 * 1000; // 7 days
export const CONTEXT_BEFORE = 10;
export const CONTEXT_AFTER = 1;

export const CATEGORY_LABELS: Record<string, string> = {
  SELF_HARM_SUICIDAL_IDEATION: "Self-Harm & Suicide Risk",
  ABUSE_NEGLECT_DOMESTIC_VIOLENCE: "Abuse & Domestic Violence",
  THREATS_VIOLENCE_TOWARD_OTHERS: "Threats & Violence",
  SUBSTANCE_USE_RISK: "Substance Use Risk",
  EATING_DISORDER_RISK: "Eating Disorder Risk",
  PSYCHOTIC_SYMPTOMS: "Psychotic Symptoms",
  CLINICAL_ASSESSMENT: "Clinical Assessment",
  HATE_HARASSMENT: "Hate & Harassment",
  SEXUAL_IMAGERY: "Sexual Imagery",
  GROOMING: "Grooming",
  SEXUAL_ADVANCES: "Sexual Advances",
};

export const PRIORITY_CONFIG: Record<
  string,
  {
    label: string;
    pillBg: string;
    pillText: string;
    rowBg: string;
    rowBorder: string;
  }
> = {
  HIGH: {
    label: "High risk",
    pillBg: "bg-red-500",
    pillText: "text-white",
    rowBg: "bg-red-50",
    rowBorder: "!border-l-4 !border-l-red-500",
  },
  MEDIUM: {
    label: "Medium risk",
    pillBg: "bg-orange-400",
    pillText: "text-white",
    rowBg: "bg-orange-50",
    rowBorder: "!border-l-4 !border-l-orange-400",
  },
  STANDARD: {
    label: "Standard",
    pillBg: "bg-zinc-200",
    pillText: "text-zinc-700",
    rowBg: "",
    rowBorder: "",
  },
};

export const OVERDUE_HOURS: Record<string, number> = {
  HIGH: 24,
  MEDIUM: 48,
};
